import { render } from "./TableHeader.vue?vue&type=template&id=5a621acd&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"

import "./TableHeader.vue?vue&type=style&index=0&id=5a621acd&scoped=true&lang=css"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a621acd"]])

export default __exports__